import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

// import moment from 'moment';

// import firebase from 'firebase/app';
// require("firebase/firestore");

const styles = theme => ({

})

class PassActivationDialog extends Component {
  state = {
    open: this.props.open,
    processing: false,
  };

  handleSubmit = () => {
    if (this.props.customer && this.props.passes) {
      this.startProcessing();
      this.submitPassActivation()
        .then(this.stopProcessing)
        .then(this.handleRequestClose);
    }
  }

  submitPassActivation = () => {
    console.log(this.props.passRecord);
    this.handlePassActivationDialogClose();
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open, });
    }
  }

  render() {
    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Pass Activation</DialogTitle>
        <DialogContent>
          <DialogContentText>Activate this pure study pass?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.processing}
            onClick={this.handleSubmit} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

PassActivationDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  passRecord: PropTypes.object,
};

export default withStyles(styles)(PassActivationDialog);
